import Vue from 'vue'
import Router from 'vue-router'
import List from '../components/List.vue'
import BangDan from '../components/BangDan.vue'
import GongGao from '../components/GongGao.vue'
import BotTom from '../components/BotTom.vue'
import ZhongXin from '../components/ZhongXin.vue'
import GaoList from '../components/GaoList.vue'
import DaSaiall from '../components/DaSaiall.vue'
import HeadTop from '../components/HeadTop.vue'
import ceshi from '../components/ceshi.vue'
import GongGaoson from '../components/GongGaoson.vue'
import HomePages from '../components/HomePages.vue'
import WeiKeson from '../components/WeiKeson.vue'
import PtSon from '../components/PtSon.vue'
import DengLu from '../components/DengLu.vue'
import ZhuCe from '../components/ZhuCe.vue'
import CansaiZhuce from '../components/CansaiZhuce.vue'
import GeRenzx from '../components/GeRenzx.vue'
import GeRenzxone from '../components/GeRenzxone.vue'
import GeRenzxtwo from '../components/GeRenzxtwo.vue'
import GeRenzxthree from '../components/GeRenzxthree.vue'
import GeRenxinxi from '../components/GeRenxinxi.vue'
import PtSontwo from '../components/PtSontwo.vue'
import PtSonthree from '../components/PtSonthree.vue'

Vue.use(Router)


export default new Router({
    // base: '/headtop',
    // mode: 'history',
    //切换路由回到顶部
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [

        {
            path: '/list',
            name: 'List',
            component: List
        },

        {
            path: '/bangdan',
            name: 'BangDan',
            component: BangDan
        },
        {
            path: '/gonggao',
            name: 'GongGao',
            component: GongGao
        },
        {
            path: '/bottom',
            name: 'BotTom',
            component: BotTom
        },

        {
            path: '/',
            name: 'HeadTop',
            component: HeadTop,
            children: [{
                    path: '/zhongxin',
                    name: '/ZhongXin',
                    component: ZhongXin
                },
                {
                    path: '/gaolist',
                    name: '/GaoList',
                    component: GaoList
                },
                {
                    path: '/dasaiall',
                    name: '/DaSaiall',
                    component: DaSaiall
                },
                {
                    path: '/gerenzxone',
                    name: 'GeRenzxone',
                    component: GeRenzxone
                },
                {
                    path: '/',
                    name: 'HomePages',
                    component: HomePages,

                },
                {
                    path: '/ptson',
                    name: 'PtSon',
                    component: PtSon
                },
                {
                    path: '/weikeson',
                    name: 'WeiKeson',
                    component: WeiKeson
                },
                {
                    path: '/gonggaoson',
                    name: 'GongGaoson',
                    component: GongGaoson
                },
            ]

        },
        {
            path: '/ceshi',
            name: 'ceshi',
            component: ceshi
        },



        {
            path: '/denglu',
            name: 'DengLu',
            component: DengLu
        },
        {
            path: '/zhuce',
            name: 'ZhuCe',
            component: ZhuCe
        },
        {
            path: '/cansaizhuce',
            name: 'CansaiZhuce',
            component: CansaiZhuce
        },

        {
            path: '/gerenzxtwo',
            name: 'GeRenzxtwo',
            component: GeRenzxtwo
        },
        {
            path: '/gerenzx',
            name: 'GeRenzx',
            component: GeRenzx
        },
        {
            path: '/gerenzxthree',
            name: 'GeRenzxthree',
            component: GeRenzxthree
        },
        {
            path: '/gerenxinxi',
            name: 'GeRenxinxi',
            component: GeRenxinxi
        },
        {
            path: '/ptsontwo',
            name: 'PtSontwo',
            component: PtSontwo
        },
        {
            path: '/ptsonthree',
            name: 'PtSonthree',
            component: PtSonthree
        }

    ]
})



const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
    }
    // 切换路由后保持在顶部


// WEBPACK FOOTER //
// ./src/router/index.js